<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">点检单号</label>
            <em class="weui-form-preview__value">{{ form.main.ec_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ec_date">
            <label class="weui-form-preview__label">{{customLabel.ec_date || "点检日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ec_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_name">
            <label class="weui-form-preview__label">{{customLabel.eq_name || "设备名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.eq_orispeccode || "规格型号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_brand">
            <label class="weui-form-preview__label">{{customLabel.eq_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_brand
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_kind">
            <label class="weui-form-preview__label">{{customLabel.eq_kind || "设备类别"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_kind
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_check_time">
            <label class="weui-form-preview__label">{{customLabel.eq_check_time || "检查周期"}}</label>
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'year'"
              >{{ form.main.eq_check_time }}年</span
            >
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'month'"
              >{{ form.main.eq_check_time }}月</span
            >
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'week'"
              >{{ form.main.eq_check_time }}周</span
            >
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'day'"
              >{{ form.main.eq_check_time }}日</span
            >
          </div>
          <div class="weui-form-preview__item" slot="eq_state">
            <label class="weui-form-preview__label">{{customLabel.eq_state || "设备状态"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_state
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.ed_detno"
        >
          <div class="form-detail-preview_num">{{ item.ecd_detno }}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="ecd_project">
            <label class="weui-form-preview__label">{{customLabel.ecd_project || "检查项目"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ecd_project }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ecd_method">
            <label class="weui-form-preview__label">{{customLabel.ecd_method || "检查方法"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ecd_method }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ecd_standard">
            <label class="weui-form-preview__label">{{customLabel.ecd_standard || "检查标准"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ecd_standard }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ecd_result">
            <label class="weui-form-preview__label">{{customLabel.ecd_result || "结果"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ecd_result }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ecd_describe">
            <label class="weui-form-preview__label">{{customLabel.ecd_describe || "故障描述"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ecd_describe }}
            </span>
          </div>
           </custom-layout>
          <file-list v-model="item.ecd_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnin_repair"
        >转维修</a
      >
      <router-link
        :to="'/oa/equipment_check_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_remove"
        >删除</a
      >
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import Share from "@/components/button/Share.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    Share,
  },
  data() {
    return {
      baseUrl: "/api/oa/equipmentCheck",
      codeField: "ec_code",
      statusField: "ec_status_code",
      caller: "EquipmentCheck",
      xtype: "oa-equipmentcheck-formpanel",
      form: {
        main: {},
        items: [],
      },
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.ec_code,
        bizType: "EquipmentCheck",
        bizId: main.id,
        viewType: "oa-equipmentcheck-formpanel",
        title: "设备点检" + main.ec_code,
      };
    },
  },
  methods: {
    turnin_repair() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        data = {
          name: main.eq_name,
          describe: '',
        };
      let i = 1;
      items.forEach((item) => {
        if (item.ecd_describe) {
          data.describe += i + "." + item.ecd_describe + "\n";
          i++;
        }
      });
      me.$router.push({
        name: "OaRepairEdit",
        params: {
          data: data,
        },
      });
    },
  },
};
</script>